<script setup lang="ts">
import { PropType } from 'vue'
import FullProduct from '~/models/Product/FullProduct'
import Modal from '~/components/Modal.vue'

defineProps({
    product: {
        type: Object as PropType<FullProduct>,
        required: true,
    },
})

const openModal = () => {
    useNuxtApp().$bus.$emit('showModal', 'expres-modal')
}
</script>

<template>
    <div>
        <button class="btn btn-express rounded-25" type="submit" @click="openModal()">
            {{ $t('product.forPickupWithinPharmacy') }}
        </button>
        <Modal modal-class="expres-modal top-0 text-center" modal-name="expres-modal" size="lg" :backdrop-close="false">
            <div class="content" v-html="product.clickAndCollectData?.expresModalContent"></div>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
.btn-express {
    width: 100%;
    max-width: 250px;
    height: 39px;

    @media (max-width: 480px) {
        margin-top: 10px;
    }

    background-color: $color-green;

    &:hover {
        color: $color-white;
        background-color: $color-green-dark;
    }
}
</style>
